import { Text } from "@/components/ui/text";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as Speech from 'expo-speech';
import RichText from "./RichText";
import i18n from 'i18n-js';

export default function ItemText({ title, text, isSimulator = false}) {
    const settings = useSelector((state) => state.settings)

    const [opts, setOpts] = useState({})
    const [active, setActive] = useState(0)

    const regex = /([^\[\*]*)((\[([^\]]*)\]\(([^)]+)\))|(\*\*([^*]+)\*\*))([^\[\*]*)/g;
    const cleanText = (text) => {
        let cleaned = '';
        let match;
        while ((match = regex.exec(text)) !== null) {
            if (match[1] != '') {
                cleaned += match[1];
            }
            if (match[2].startsWith('[')) {
                cleaned += i18n.t('message.linkedTask') + ' ' + (match[4] || match[5]);
            } else {
                cleaned += match[7];
            }
            if (match[8] != '') {
                cleaned += match[8];
            }
        }
        if (cleaned != '') {
            return cleaned
        }   
        return text
    };

    useEffect(() => {
        const newOpts = settings?.voice?.identifier ? { voice: settings?.voice?.identifier } : {}
        console.log('OPTS', newOpts)
        if (settings.speechEnabled && !isSimulator) {
            Speech.speak(title, newOpts)
            Speech.speak(cleanText(text), newOpts)
        }
        setOpts(newOpts)
        return () => {
            Speech.stop()
        }
    }, [title, settings.speechEnabled])

    const toggleSpeech = (speak, id) => {
        Speech.isSpeakingAsync().then(speaking => {
            if (speaking) {
                Speech.stop()
            } 
            if (!speaking || id != active) {
                Speech.speak(cleanText(speak), opts)
                setActive(id)
            }
        })
    }

    return (
        <>
            <Text bold onPress={() => toggleSpeech(title, 1)} className="text-2xl leading-2xl text-secondary-900">{title}</Text>
            {true ? <RichText onPress={() => toggleSpeech(text, 2)} text={text} /> : <Text onPress={() => toggleSpeech(text, 2)} className="mt-2 text-2xl text-secondary-900">{text}</Text>}
        </>
    );
}